import { Avatar, Button, ImageList, ImageListItem, Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useStoreState } from 'pullstate';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BackdropLoader from '../../components/BackdropLoader.jsx';
import styles from '../../components/styles/css/Navbar.module.css';
import { AppStore } from '../../stores/AppStore.js';
import { api } from '../../utils/apiFunctions';
import MenuPeopleBuilder from './MenuPeopleBuilder.jsx';
import MenuSettings from './MenuSettings.jsx';

const Navbar = () => {
    const [userLogged, setUserLogged] = useState()
    const user = useStoreState(AppStore, s => s.user)
    const employees = useStoreState(AppStore, s => s.employees)
    const isAdmin = user?.is_lifecycle_admin || false
    const isHRAdmin = user?.is_hr_admin || false
    const [openBackdrop, setOpenBackdrop] = useState(false)
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
    const apiEnvironment = useStoreState(AppStore, s => s.apiEnvironment);
    const navigate = useNavigate()

    useEffect(() => {
        if (user != 'undefined') {
            setUserLogged(user)
            
        } else {
            // return <NotAuth />
        }

    }, [])

    useEffect(() => {
        // Update userLogged photo when employee photo updates in store
        if (user?.id && employees) {
            const updatedEmployee = employees.find(emp => emp.id === user.id);
            if (updatedEmployee?.photo_url) {
                setUserLogged(prev => ({
                    ...prev,
                    photo_url: updatedEmployee.photo_url
                }));
            }
        }
    }, [user?.id, employees])

    const copyGoals = async () => {
        setOpenBackdrop(true)
        try {
            const response = await api.post('/copy-goals')
            if (response.data.status !== 200) {
                openAlert(response?.data?.message, 'error')
                setOpenBackdrop(false)
                return
            }
            openAlert(response?.data?.message, 'success')
            setOpenBackdrop(false)
        } catch (error) {
            openAlert('Error', 'error')
            console.log(error)
            setOpenBackdrop(false)
        }
    }

    return (
        <AppBar style={{ height: '4rem' }} position="fixed"
            sx={{ backgroundColor: '#2B2B2B' }}>
            <Toolbar>
                <ImageList sx={{ width: '30rem' }} >
                    <ImageListItem>
                        <img src="https://images.squarespace-cdn.com/content/v1/562af2bee4b094a1579b7245/1510334525983-3D9G5SP3INR4JF4YRGCO/etro_white.png?format=1500w" />
                    </ImageListItem>
                </ImageList>
                {openBackdrop && (
                    <BackdropLoader openBackdrop={open} />
                )}

                <Stack direction='row' className={styles.photo_name}>
                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Button color="inherit" component={Link} to="/employee">ETRO Team</Button>
                        {/* <Button color="inherit" component={Link} to="/users/datagrid">DataGrid</Button> */}
                        <MenuPeopleBuilder />
                    </Stack>
                    { process.env.REACT_APP_ENVIRONMENT !== 'prod' && <h1 style = {{whiteSpace: "nowrap", fontSize:"1.7rem"}}>API: {apiEnvironment}</h1>}
                    <Stack direction='row' justifyContent="center" alignItems="center" >
                        {isAdmin || isHRAdmin ? <MenuSettings isAdmin={isAdmin} /> : ''}
                        <Button color='inherit' onClick={() => {
                            navigate(`/employee/profile/${userLogged?.id}`)
                        }}>
                            <Avatar src={userLogged?.photo_url ?? ''} sx={{ width: 40, height: 40, marginRight: 1 }} />
                            {userLogged?.full_name ?? ''}
                        </Button>
                    </Stack>
                </Stack>
            </Toolbar>
        </AppBar >

    )
}

export default Navbar;